import { createContext } from "react";
import { LocalStorageContextType } from "./LocalStorageContext.types";

export const LocalStorageContext = createContext<LocalStorageContextType>(
  {} as LocalStorageContextType,
);
